import React from 'react';
import { TALENT_ARR } from '../../data/define';
import { useTranslation } from '../../hook/useTranslation';

const talentColors: Record<string, string> = {
  language: '#FF6B6B',
  music: '#4DABF7',
  physical: '#51CF66',
  math: '#FCC419',
  space: '#FF922B',
  relationship: '#845EF7',
  reflection: '#E599F7',
  nature: '#20C997',
};

interface AnalysisResultChartProps {
  intelligence: number;
  score: number;
}

const AnalysisResultChart: React.FC<AnalysisResultChartProps> = ({ intelligence, score }) => {
  const { t } = useTranslation();
  const talent = TALENT_ARR.find((i) => i.id === intelligence);
  const color = talentColors[talent?.key || ''] || '#5EBEBB';

  return (
    <div className="flex flex-col items-start gap-1 p-[8px] bg-[rgba(255,255,255,0.2)] rounded-[8px] w-full">
      <div className="w-full flex justify-between items-center text-[12px]">
        <div className="flex items-center gap-[4px]">
          <div className="w-[12px] h-[12px] rounded-full border border-white shrink-0" style={{ backgroundColor: color }} />
          <div className="font-[700] whitespace-nowrap">{t(`talent.${talent?.key}`)}</div>
        </div>
        <div className="font-[400] text-[12px] whitespace-nowrap">{t('report.summary.score', { score: score })}</div>
      </div>

      <div className="w-full h-2 rounded-[2px] mt-1 relative flex shrink-0">
        <div
          className="h-full rounded-[2px]"
          style={{ width: `${score}%`, backgroundColor: color }}
        />
      </div>
    </div>
  );
};

export default AnalysisResultChart;
